/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetDraftCustomerOrdersByCommandID(commandID) {
  const response = await $.soap({
    body: {
      GetDraftCustomerOrdersByCommandID: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        CommandID: commandID
      }
    },
    blueprintArrays: ['GetDraftCustomerOrdersByCommandIDResponse.tuple'],
    blueprint: {
      orders: [
        '$..GetDraftCustomerOrdersByCommandIDResponse.tuple',
        {
          id: '$.old.CustomerOrder.ID',
          orderFormTypeID: '$.old.CustomerOrder.OrderFormTypeID',
          formCode: '$.old.CustomerOrder.FormCode',
          formName: '$.old.CustomerOrder.FormName',
          statusID: '$.old.CustomerOrder.StatusID',
          externalOrderStatus: '$.old.CustomerOrder.ExternalOrderStatus',
          createdOn: '$.old.CustomerOrder.CreatedOn',
          updatedOn: '$.old.CustomerOrder.UpdatedOn'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.orders;
}
